
import { useState, useParams, FaSearch, FaFileExcel, DataTable, ToastContainer, moment, MdArrowDownward, noDatapng, overlayStyle, loaderStyle } from '../../common/common';
// import { useErrorContext } from '../../context/ErrorContext';
import MidsellerBuyers from '../../middleware/Distributors/MidsellerBuyers';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
const ViewDistributors = () => {
  const { type } = useParams();
  const [issidebarOpen, setIssidebarOpen] = useState(true);
  // const { error } = useErrorContext();
  const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
  const { users,userPlan, seacrh, setSearch, exporttoExcelData, filteredbuyers, isLoading } = MidsellerBuyers(type);
  if (Array.isArray(users) && users.length > 0) {
    var AppID = users[0]['AppID'];
    var ProfilePic = users[0]['ProfilePic'];
    var usertype = users[0]['UserType'];
    var username = users[0]['FullName'];
    // var CompanyName = users[0]['CompanyName'];
    // var userAddress1 = users[0]['Address1'];
    // var userAddress2 = users[0]['Address2'];
    // var Mobile = users[0]['Mobile'];
    // var EmailAddress = users[0]['EmailAddress'];
    // var plan_end_date_m = moment(RegistrationDate).add(10, 'days').format('DD-MMM-YYYY');
    // var RegistrationDate = users[0]['RegistrationDate'];
    // var RegistrationDate = moment(RegistrationDate).format('DD-MMM-YYYY');
  }
   if(Array.isArray(userPlan) && userPlan.length > 0){
        var planID = userPlan[0]['plan_id'];
    }
  // const getInitials = (name) => {
  //   const nameArray = name.split(' ');
  //   return nameArray.map(word => word[0].toUpperCase()).join('');
  // };
  const columns = [
    {
      name: "Profile Picture",
      sortable: true,
      selector: (row) => {
        // Check if `row.full_name` is null or undefined
        const firstLetter = row.full_name ? row.full_name.substring(0, 1) : '';

        return (
          <span className="relative inline-flex items-center justify-center font-medium w-10 h-10 leading-[4rem] text-[1.25rem] rounded-full avatar-xl bg-primary avatar-rounded !bg-[#3D5EE1] !border-[1px] !border-[solid] !border-[#3D5EE1] text-[#FFF]">
            <span className="avatar-title">{firstLetter}</span>
          </span>
        );
      }
    },
    {
      name: "Buyer Name",
      sortable: true,
      selector: (row) => <div><p className='text-blue-700 text-md font-semibold cursor-pointer'>{row.full_name}</p><p className='text-sm font-semibold text-gray-400 my-1'> {row.company_name}</p></div>,
    },
    {
      name: "Address",
      sortable: true,
      selector: (row) => <div><p className='text-blue-700 text-md font-semibold cursor-pointer'>{row.city_name}{", "}{row.state_name}{", "}{row.country_name}</p></div>,
    },
    {
      name: " Created Date",
      sortable: true,
      selector: (row) => <p className=" text-md text-center px-2 text-md p-2  text-black  font-semibold rounded-md"> {moment(row.created_date).format("DD MMM YYYY hh:mm")}</p>
    },
    {
      name: "Modified Date",
      sortable: true,
      selector: (row) => <p className=" text-md text-center px-2 text-md p-2  text-black  font-semibold rounded-md">{moment(row.modified_date).format("DD MMM YYYY hh:mm")}</p>
    },
  ]

  return (
    <div className="md:flex md:flex-row md:w-full">
      <div className={`${issidebarOpen ? 'w-0  md:w-1/5' : 'w-0'}`}>
        <Sidebar handleSideBar={handlesetIssidebarOpen} issidebarOpen={issidebarOpen} UserTypeData={usertype} userName={username} appID={AppID} profilePic={ProfilePic} currentUserType={type} currentplan={planID} />
      </div>
      <div className={`${issidebarOpen ? 'w-full md:ml-2 md:w-[80%]' : 'ml-20 w-full'} `} >
        <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype} currentUserType={type} />
        <div className="grid grid-cols-12">
          <div className="col-start-1 col-end-13">
            <div className=" px-4 pt-4 text-xl  text-[#1e3a8a]  ">
              <div className='px-3'>
                <h1 className=' text-lg text-theme-color-text font-bold'>Buyers</h1>
                <p className=' text-gray-600 text-[16px] '>select attributes as per your products range, code, name and category are required attributes. you have to an option to include all attributes while adding product data but displaying only few of them to your buyers.  </p>
                <div className="border-0 flex-row rounded-xl bg-white shadow-xs">
                  <div className=' relative flex flex-col min-w-0 break-words'>
                    {/* <h5 className=" capitalize text-xl font-bold mb-0">View Distributor</h5> */}
                    {/* <div className='flex flex-row justify-between items-center'>
                          <div className=' rounded-b-md mt-5  overflow-x-hidden bg-white flex flex-row items-center justify-between w-full '>
                            <div className=" justify-start float-left w-full   ">
                              <div className='relative bg-gray-100 p-2 w-full  rounded-md border-2 border-solid border-gray-200' >
                                <FaSearch className='h-5 w-5 absolute left-3 ' />
                                <input className="bg-transparent ml-6 pl-5 focus:outline-none w-full  " type="text" name="searchbox" id='searchbox' placeholder='Search anything from table '
                                  value={seacrh}
                                  onChange={(e) => setSearch(e.target.value)} />
                              </div>
                              <div>
                              </div>
                            </div>
                          </div>
                          <div className='flex flex-row'>
                            <button type="submit" className="relative mx-2 rounded-md group px-3 h-12 mt-5 flex space-x-2 items-center bg-blue-600 text-white  w-[220px]" onClick={() => exporttoExcelData()}>
                              <span className="relative text-md text-white font-semibold pl-0">Download Excelsheet</span>
                              <div className="flex items-center h-12 w-12 rounded-full bg-blue-600 absolute right-[0px] z-20 drop-shadow-2xl ">
                                <FaFileExcel className="h-5 w-5 text-white translate-x-4 transition duration-300 " />
                              </div>
                            </button>
                          </div>
                        </div> */}

                    <div className="flex flex-col md:flex-row md:justify-between md:items-center w-full">
                      {/* Search Section */}
                      <div className="w-full md:max-w-md mt-5"> {/* Limit search width */}
                        <div className="relative bg-gray-100 p-2 rounded-md border-2 border-solid border-gray-200">
                          <FaSearch className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
                          <input
                            className="bg-transparent ml-6 pl-5 focus:outline-none w-full text-sm placeholder-gray-500"
                            type="text"
                            name="searchbox"
                            id="searchbox"
                            placeholder="Search"
                            value={seacrh}
                            onChange={(e) => setSearch(e.target.value)}
                          />
                        </div>
                      </div>

                      {/* Button Section */}
                      <div className="mt-4 md:mt-5 md:ml-3 flex justify-center md:justify-end">
                        <button
                          type="submit"
                          className="flex items-center justify-center gap-2 rounded-md px-3 py-2 bg-blue-600 text-white 
                     w-full sm:w-[200px] text-sm sm:text-base font-semibold"
                          onClick={() => exporttoExcelData()}
                        >
                          <FaFileExcel className="h-5 w-5" />
                          Download Excelsheet
                        </button>
                      </div>
                    </div>


                    {filteredbuyers?.length > 0 ? (
                      <DataTable
                        columns={columns}
                        data={filteredbuyers}
                        // selectableRows
                        pagination
                        // selectableRowsComponent={Checkbox} // Pass the function only
                        sortIcon={<MdArrowDownward />} // Material icon for sorting
                      />
                    ) : (
                      <div className="flex flex-col items-center">
                        <img src={noDatapng} alt="No Data Found" height={260} width={260} />
                        <h1 className="text-lg text-gray-300 font-bold mt-4">Oops! No Data Found</h1>
                      </div>
                    )}


                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <ToastContainer />
      {isLoading && (
        <div style={overlayStyle}>
          <div style={loaderStyle}>Loading...</div>
        </div>
      )}
    </div>
  )
}

export default ViewDistributors